import {
    GET_INCOME_EXPENDITURE_REPORT,
    GET_BALANCE_SHEET_REPORT,
    GET_TRIAL_BALANCE_REPORT,
    GET_GROUP_LEDGER_REPORT,
    GET_MONTHLY_INCOME_REPORT,
    GET_MONTHLY_EXPENDITURE_REPORT,
    CLEAR_ACCOUNT_REPORTS_STATE,
} from '../../index.types';

export const getIncomeExpenditureReport = (data) => ({ type: GET_INCOME_EXPENDITURE_REPORT, data });
export const getBalanceSheetReport = (data) => ({ type: GET_BALANCE_SHEET_REPORT, data });
export const getTrialBalanceReport = (data) => ({ type: GET_TRIAL_BALANCE_REPORT, data });
export const getGroupLedgerReport = (data) => ({ type: GET_GROUP_LEDGER_REPORT, data });
export const getMonthlyIncomeReport = (data) => ({ type: GET_MONTHLY_INCOME_REPORT, data });
export const getMonthlyExpenditureReport = (data) => ({ type: GET_MONTHLY_EXPENDITURE_REPORT, data });
export const clearAccountReportsState = () => ({ type: CLEAR_ACCOUNT_REPORTS_STATE });
